<template>
  <div id="app">
    <template v-if="!thumb">
      <canvas id="canvas" />
      <div id="bg" />
    </template>
    <router-view />
    <CustomTabBar v-if="istab" />
  </div>
</template>

<script>
import CustomTabBar from "@/components/CustomTabBar";
import { getThumb } from "@/api/config";
import { mapGetters } from "vuex";
export default {
  components: {
    CustomTabBar,
  },
  data() {
    return {
      thumb: ""
    };
  },
  computed: {
    ...mapGetters(["istab"]),
  },
  mounted() {
    this.getData();
    this.getThumb();
  },
  methods: {

    getData() {
      this.$store.dispatch("cultureList", { type: "culture" });
      this.$store.dispatch("industrialList", { type: "industrial" });
      this.$store.dispatch("strategyList");
      this.$store.dispatch("foodList");
      this.$store.dispatch("liveList");
      this.$store.dispatch("attrList");
    },

    getThumb() {
      const type = window.innerWidth > 750 ? "pcbg" : "thumb";
      getThumb({ type: type }).then((ret) => {
        if (ret) {
          this.initCanvas(ret.value);
        } else {
          document.querySelector("#canvas").style.display = "none";
          document.querySelector("#bg").style.display = "none";
        }
      });
    },

    initCanvas(src) {
      const canvas = document.querySelector("#canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      const imgMask = new Image();
      let isHide = 0;

      img.src = src;
      imgMask.src = require("@/assets/cloud-texture.png");

      img.onload = function () {
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        canvas.style.display = "bloack";
        draw();
      };

      canvas.addEventListener("click", function () {
        isHide = 1;
        alphaPlay(canvas, "hiden");
        alphaPlay(document.querySelector("#bg"), "hiden");
      });

      let i = 0;
      function draw() {
        i += 20;
        const maskX = (canvas.width - (70 + i)) / 2;
        const maskY = (canvas.height - (40 + i)) / 2;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = "source-over";

        ctx.drawImage(imgMask, maskX, maskY, 70 + i, 40 + i);

        ctx.globalCompositeOperation = "source-in";
        ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);

        if (i > 4500 && isHide === 0) {
          // canv.style.display = "none";
          isHide = 1;
          alphaPlay(canvas, "hiden");
          alphaPlay(document.querySelector("#bg"), "hiden");
        }
        window.requestAnimationFrame(draw);
      }

      function alphaPlay(obj, method) {
        // method有两个值show或hiden

        var n = method === "show" ? 0 : 100;
        var ie = !!window.ActiveXObject;

        var time = setInterval(function () {
          if (method === "show") {
            if (n < 100) {
              n += 10;

              if (ie) {
                obj.style.cssText = "filter:alpha(opacity=" + n + ")";
              } else {
                n === 100
                  ? (obj.style.opacity = 1)
                  : (obj.style.opacity = "0." + n);
              }
            } else {
              clearTimeout(time);
            }
          } else {
            if (n > 0) {
              n -= 10;

              if (ie) {
                obj.style.cssText = "filter:alpha(opacity=" + n + ")";
              } else {
                obj.style.opacity = "0." + n;
              }
            } else {
              canvas.style.display = "none";
              document.querySelector("#bg").style.display = "none";
              clearTimeout(time);
            }
          }
        }, 60);
      }
    },
  },
};
</script>

<style>
@import url("@/assets/font/iconfont.css");

body {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica,
    Segoe UI, Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB",
    "Microsoft Yahei", sans-serif;
  overflow: hidden;
}

.thumb-img img {
  margin: auto;
  width: auto !important;
  height: 100vh !important;
  overflow: hidden;
}

#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.list::-webkit-scrollbar {
  width: 0;
  height: 0;
}

* {
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  display: block;
}

#canvas {
  height: 100vh;
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

#bg {
  width: 100vw;
  background-color: #fff;
  height: 100vh;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9998;
}

@media screen and (max-width: 500px) {
  #canvas {
    width: 100vw;
  }
}
</style>
